module.exports = __webpack_public_path__ + "media/iconic/data-transfer-c8654a60.svg";